import { useQuery } from "@tanstack/react-query";
import { api, unwrap } from "@/api/client";

export const configKeys = { public: ["config", "public"] as const };

/** Platform switches the apps react to (maintenance, features, fees, SMS). */
export function usePublicConfig() {
  return useQuery({
    queryKey: configKeys.public,
    queryFn: () => unwrap(api.GET("/api/v1/config/")),
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * False when the platform runs without SMS: no phone codes, and a verified email stands in for a verified phone.
 * Defaults to true until the config loads, so nothing phone-related disappears while loading.
 */
export function useSmsEnabled(): boolean {
  return usePublicConfig().data?.sms_enabled ?? true;
}
